import React from "react";
import { Box, Grid } from "@mui/material";
import "./TrainingGridListing.scss";
import WeekDays from "../weekDays";
import Google from "../../Images/google-cloud.svg";
import Aws from "../../Images/aws-cloud.svg";

// const TrainingGridListing = (props) => {
// 	const { training, onClick } = props;
// 	return (
// 		<>
// 			<div className="gridTraining" onClick={() => onClick(training)}>
// 				<Box
// 					className="statusLebal medium_f_bold"
// 					style={{
// 						color: training?.status_colour?.color,
// 						background: training?.status_colour?.background,
// 					}}
// 				>
// 					{training?.status_colour?.status}
// 				</Box>
// 				<Box className="TraningGridTitle medium_f_bold">
// 					Training Name - {training?.title}
// 				</Box>
// 				<Box className="trainingDetails small_f">{training?.description}</Box>
// 				<Box>
// 					<Grid container columnSpacing={2} rowSpacing={1}>
// 						<Grid item xs={12} sm={10} md={10} lg={9.6}>
// 							<Box className="trainingDayTimeGrid">
// 								<Box className="Training_date">
// 									{training?.startDate} - {training?.endDate}
// 								</Box>
// 								<Box className="Training_date">
// 									{training?.startTime} to {training?.endTime}
// 								</Box>
// 								<Box className="dayLabel">
// 									<WeekDays days={training?.days} />
// 								</Box>
// 							</Box>
// 						</Grid>
// 						<Grid item xs={12} sm={2} md={2} lg={2.4}>
// 							<Box className="GridstartInContainer">
// 								<Grid container>
// 									<Grid
// 										item
// 										xs={12}
// 										sm={12}
// 										md={12}
// 										lg={12}
// 										className="start_in"
// 									>
// 										Start In
// 									</Grid>
// 									<Grid
// 										item
// 										xs={12}
// 										sm={12}
// 										md={12}
// 										lg={12}
// 										className="no_of_days medium_f_bold"
// 									>
// 										7
// 									</Grid>
// 									<Grid
// 										item
// 										xs={12}
// 										sm={12}
// 										md={12}
// 										lg={12}
// 										className="start_in_days"
// 									>
// 										Days
// 									</Grid>
// 								</Grid>
// 							</Box>{' '}
// 						</Grid>
// 					</Grid>
// 				</Box>
// 			</div>
// 		</>
// 	);
// };

const TrainingGridListing = (props) => {
  const { training, onClick } = props;
  const add3Dots = (string, limit) => {
    let dots = "...";
    if (string) {
      if (string.length > limit) {
        string = string.substring(0, limit) + dots;
      }
      return string;
    }
  };
  return (
    <>
      <div className="gridTraining" onClick={() => onClick(training)}>
        <Box
          className="statusLebal medium_f_bold"
          style={{
            color: training?.status_colour?.color,
            background: training?.status_colour?.background,
          }}
        >
          {training.status_colour?.status}
        </Box>
        <Box display="flex">
          <Box>
            {training?.cloud_type === "AWS" ? (
              <img
                src={Aws}
                height={20}
                style={{ marginRight: "5px", marginTop: "3px" }}
              />
            ) : (
              <img src={Google} height={20} style={{ marginRight: "5px" }} />
            )}
          </Box>
          <Box className="TraningGridTitle large_f_bold">
            Training Name -{add3Dots(training?.title, 20)}
          </Box>
        </Box>

        <Box className="trainingDetails trainingDetailHeight small_f">
          {add3Dots(training?.description, 100)}
        </Box>
        <Box>
          <Grid container columnSpacing={2} rowSpacing={1}>
            <Grid item xs={12} sm={10} md={10} lg={9.6}>
              <Box className="trainingDayTimeGrid">
                <Box className="Training_date">
                  {training?.startDate} - {training?.endDate}
                </Box>
                <Box className="Training_date">
                  {training?.startTime} to {training?.endTime}
                </Box>
                <Box className="dayLabel">
                  <WeekDays
                    days={training?.days}
                    training_dates={training?.training_dates}
                  />
                </Box>
              </Box>
            </Grid>
            {(training?.status === "in-progress" ||
              training?.status === "pending") && (
              <Grid item xs={12} sm={2} md={2} lg={2.4}>
                <Box className="GridstartInContainer">
                  <Grid container>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      className="start_in"
                    >
                      Start In
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      className="no_of_days medium_f_bold"
                    >
                      {training?.diffs}
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      className="start_in_days"
                    >
                      Days
                    </Grid>
                  </Grid>
                </Box>{" "}
              </Grid>
            )}
          </Grid>
        </Box>
      </div>
    </>
  );
};

export default TrainingGridListing;
